import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { adminMainUrl } from "../../../Config.jsx";
import DashIcon from "./DashIcon";
import { recentActivities as fallbackActivities } from "./dashboardData";

/**
 * ActivityList – vertical feed of recent activity entries.
 */
const ActivityList = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchRecentActivityData = async () => {
      const token = Cookies.get('token');
      const user_id = Cookies.get('flexichain_user_id');
      try {
        const response = await fetch(`${adminMainUrl}/api/operation-dashboard-recent-activity`, {
          method: "GET",
          headers: {
            'auth-token': token || '',
            'Authorization': token ? (token.startsWith('Bearer ') ? token : `Bearer ${token}`) : '',
            'user_id': user_id || '',
            'user-id': user_id || '',
            'Content-Type': 'application/json',
          }
        });
        const resData = await response.json();
        if (response.ok && resData?.code === 200) {
          setData(resData.data);
        }
      } catch (err) {
        console.error("Error fetching recent activity data:", err);
      }
    };

    fetchRecentActivityData();
  }, []);

  const itemsToDisplay = data || fallbackActivities;

  return (
    <div className="ops-card ops-activity-card">
      <div className="ops-card-header">
        <div className="ops-card-heading">
          <span className="ops-card-heading-icon ops-heading-activity">
            <DashIcon type="calendar" size={17} color="#fff" />
          </span>
          <span className="ops-card-title">Recent Activity</span>
        </div>
        <button className="ops-view-all-btn">View All</button>
      </div>

      <div className="ops-activity-list">
        {itemsToDisplay.map((a, idx) => (
          <React.Fragment key={a.id}>
            <div className="ops-activity-row">
              <div className="ops-activity-left">
                <span
                  className="ops-activity-icon-wrap"
                  style={{ background: a.iconBg }}
                >
                  <DashIcon type={a.iconType} size={16} color={a.iconColor} />
                </span>
                <span className="ops-activity-desc">{a.description}</span>
              </div>
              <span className="ops-activity-time">{a.time}</span>
            </div>
            {idx < itemsToDisplay.length - 1 && (
              <div className="ops-divider" />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ActivityList;
